var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportCorner1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 300,
    viewBox: "0 0 298 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.354 -94.5982C379.9 -94.5982 438.709 -35.8482 438.709 36.6232C438.709 109.095 379.9 167.845 307.354 167.845C234.808 167.845 175.998 109.095 175.998 36.6232C175.998 -35.8482 234.808 -94.5982 307.354 -94.5982Z",
    stroke: "#73C9FA",
    strokeWidth: 0.477169
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.824 -145.3C356.37 -145.3 415.18 -86.5496 415.18 -14.0782C415.18 58.3932 356.37 117.143 283.824 117.143C211.279 117.143 152.469 58.3932 152.469 -14.0782C152.469 -86.5496 211.279 -145.3 283.824 -145.3Z",
    stroke: "#73C9FA",
    strokeWidth: 0.477169
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.198 -182.168C379.743 -182.168 438.553 -123.417 438.553 -50.9461C438.553 21.5253 379.743 80.2753 307.198 80.2753C234.652 80.2753 175.842 21.5253 175.842 -50.9461C175.842 -123.417 234.652 -182.168 307.198 -182.168Z",
    stroke: "#73C9FA",
    strokeWidth: 0.477169
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportCorner1);
export default __webpack_public_path__ + "static/media/report_corner_1.b787faa9c9a4656ac833976833abd740.svg";
export { ForwardRef as ReactComponent };